var _defs, _circle, _path, _circle2, _circle3, _text, _text2, _text3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f5e3243a-627c-4ad5-93f1-fc3f2e7e9c55",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 403.6 391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0685580-ad35-4690-8bb9-78136aeee804{fill:#226baa;stroke:#226baa;}.a0685580-ad35-4690-8bb9-78136aeee804,.b63e8ef3-a9a3-4458-bf97-cd54e7048a5a,.e013a028-26a4-44af-a906-d98ab0579752{stroke-miterlimit:10;}.b80d0b78-434d-4ad8-9813-3f8d54de47e2,.e013a028-26a4-44af-a906-d98ab0579752{fill:#fff;}.e013a028-26a4-44af-a906-d98ab0579752{stroke:#fff;}.b63e8ef3-a9a3-4458-bf97-cd54e7048a5a{fill:#62bb46;stroke:#62bb46;}.b80d0b78-434d-4ad8-9813-3f8d54de47e2{font-size:118.4633px;font-family:LucidaHandwriting-Italic, Lucida Handwriting;font-style:italic;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a0685580-ad35-4690-8bb9-78136aeee804",
    cx: 186.7,
    cy: 186.7,
    r: 186.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e013a028-26a4-44af-a906-d98ab0579752",
    d: "M339.217,322.82s-52.7614,11.38-88.5892-31.22S231.91,205.9635,240.31,191.5635c0,0-99.91,67.6365-74.11,201.4365S309.4628,555.089,313.1314,554.7445,201.9,492,275.6284,369.7c3.6179-2.7794,24.4263-36.7336,63.5886-46.88",
    transform: "translate(-105.6 -183)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "e013a028-26a4-44af-a906-d98ab0579752",
    cx: 183.975,
    cy: 80.625,
    r: 37.125
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b63e8ef3-a9a3-4458-bf97-cd54e7048a5a",
    cx: 274.45,
    cy: 261.85,
    r: 128.65
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b80d0b78-434d-4ad8-9813-3f8d54de47e2",
    transform: "translate(160.8658 305.1553) scale(1.0203 1)"
  }, "S")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "b80d0b78-434d-4ad8-9813-3f8d54de47e2",
    transform: "translate(222.1725 305.1553) scale(1.0203 1)"
  }, "E")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "b80d0b78-434d-4ad8-9813-3f8d54de47e2",
    transform: "translate(286.7428 307.1221) scale(1.0203 1)"
  }, "A")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9f964ea.svg";
export { ForwardRef as ReactComponent };